import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";

import { BindingOfferDialog } from "./binding-offer-dialog";

type BindingOfferOrderAllTradersDialogProps = {
  cropName: string;
  amount: string;
  quarter: string;
  postalCodeLabel: string;
  parameters?: string;
  unitPrice: string;
  isPending: boolean;
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
};

const BindingOfferOrderAllTradersDialog = ({
  postalCodeLabel,
  ...props
}: BindingOfferOrderAllTradersDialogProps) => {
  return (
    <BindingOfferDialog
      {...props}
      confirmLabel={<Trans>Nastavit příkaz</Trans>}
      introText={
        <Trans>
          Prodávající tímto předkládá návrh podmínek na uzavření kupní smlouvy o
          prodeji zboží v reakci na rámcovou poptávku kupujícího, a to za
          následujících podmínek:
        </Trans>
      }
      legalConsentText={
        <Trans>
          Prodávající souhlasí s tím, že obsah kupní smlouvy se bude řídit
          obchodními podmínkami konkrétního obchodníka, který nabídku přijme.
          VOP jsou součástí kupní smlouvy.
        </Trans>
      }
      legalNoticeText={
        <Trans>
          Prodávající bere na vědomí, že kupující nemá povinnost tento návrh
          akceptovat. Kupní smlouva vzniká konfirmací tohoto závazného návrhu ze
          strany kupujícího.
        </Trans>
      }
      parity={t`FCA - ${postalCodeLabel}`}
      title={<Trans>Podmínky pro uzavření závazné nabídky</Trans>}
      tradingHoursText={
        <Trans>
          Kupující přijímá závazné nabídky v obvyklých obchodních hodinách.
        </Trans>
      }
    />
  );
};

export { BindingOfferOrderAllTradersDialog };
